import {commonActions} from '../../actions/commonActions';
import {rateSetList} from '../../actions/reportActions';
import {connect} from 'react-redux';
import List from '../../components/report/Rate';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";
import {list as userList} from '../../containers/user/ListPage';


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getUserList: (value) => {
        return(dispatch(userList(value)))
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('user/report',{params: value}).then(list => {
            console.log(list)
            dispatch(rateSetList(list.data.result));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.report.rateList,
        common       : state.common,
        userList     : state.user.list,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);